import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { TableModel } from "src/app/tinea-components/table/models/input/table-model";

export const ProviderConnectivityActions = createActionGroup({
  source: "Provider Connectivity",
  events: {
    "Search All": emptyProps(),
    "loader Start": emptyProps(),
    "Fetch Success": props<{ data: TableModel}>(),
    "Fetch Failure": props<{ message: string }>(),
    Clean: emptyProps(),
  },
});

